module.exports = __webpack_public_path__ + "img/img4.397bc48e.jpg";